import { useContext, useEffect } from 'react';

import { RelatedSearchContext } from './RelatedSearchContext';

const useRelatedSearch = (id: string, disabled?: boolean) => {
  const data = useContext(RelatedSearchContext);

  useEffect(() => {
    if (disabled) return;
    const searchParams = new URLSearchParams();
    searchParams.set('hits', '3');
    if (data.moreLikeThisUrl && id) {
      searchParams.set('id', id);
    }
    data.fetchRelated(searchParams);
  }, [id, disabled]);

  return data;
};

export default useRelatedSearch;
